/**
 * Member details modification amendment API processing
 */

import { processAmendment } from '../../shared/amendmentHelpers';

/**
 * Process member details update amendment
 *
 * @param {Object} quotationPayload - The new quotation data
 * @param {Object} policy - Current policy object
 * @param {Object} member - Member being updated
 * @param {Array} changes - Array of changed fields
 * @param {Function} updateStatus - Callback to update loading status
 * @returns {Promise} - Resolves when amendment is complete
 */
export const processMemberDetailsAmendment = async (
  quotationPayload,
  policy,
  member,
  changes,
  updateStatus
) => {
  try {
    // Calculate premium (should remain unchanged)
    const totalPremium = policy.quotation.policy_schedule_entries
      .reduce((sum, entry) => sum + (entry.premium_amount_in_cents || 0), 0) / 100;

    // Build changes list for note
    const changesList = changes.map(change =>
      `* ${change.field}: ${change.before} -> ${change.after}`
    ).join('\n');

    // Build policy note
    const noteContent = `MEMBER DETAILS UPDATED

Policy: ${policy.policy_number}

Member: ${member.first_name} ${member.last_name} (${member.relationship})

Changes:
${changesList}

Premium: BWP ${totalPremium.toFixed(2)} (No Change)`;

    // Use shared amendment processing
    return await processAmendment({
      quotationPayload,
      policy,
      noteContent,
      updateStatus
    });
  } catch (error) {
    console.error('Member details amendment error:', error);
    throw new Error(
      error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : error.response && error.response.data && error.response.data.error
        ? error.response.data.error
        : 'Failed to update member details. Please try again.'
    );
  }
};
